import qs from "./qs";
export default class API {
  constructor(host) {
    this.host = host;
  }

  setHost(host) {
    this.host = host;
  }

  async get(path, params) {
    if (params) {
      path += "?" + qs(params);
    }
    return this._call(path, "GET");
  }
  async post(path, body, headers = {}) {
    return this._call(path, "POST", body, headers);
  }
  async put(path, body) {
    return this._call(path, "PUT", body);
  }
  async delete(path) {
    return this._call(path, "DELETE");
  }
  setToken(token) {
    localStorage.setItem("token", token);
  }
  getToken() {
    return localStorage.getItem("token");
  }
  async isLoggedIn() {
    if (!this.getToken()) return false;
    try {
      let res = await this.get("/users");
      return res[0];
    } catch (e) {
      return false;
    }
  }
  async _call(path, method, body, headers = {}) {
    try {
      if (!headers["Content-Type"]) {
        headers["Content-Type"] = "application/json";
      }
      if (!headers["Authorization"])
        headers["Authorization"] = "Bearer " + this.getToken();
      if (body && typeof body !== "string") {
        body = JSON.stringify(body);
      }
      headers["x-time-zone"] =
        new Intl.DateTimeFormat().resolvedOptions().timeZone;
      headers["x-device-id"] = "automation_web";

      let res = await fetch(this.host + path, {
        method,
        headers,
        body
      });
      if (res.status !== 200) {
        let e = new Error(res.statusText);
        e.data = await res.json();
        return { error: e };
      }

      res = await res.json();
      return res;
    } catch (e) {
      console.info("API call", e);
      throw e;
    }
  }
}
